<template>
    <CRow>
        <CCol sm="12" style="padding-top: 0">
            <CCard>
                <CCardHeader>
                    <CRow>
                        <CCol>
                            <h5 style="padding: 6px">
                                {{
                                    $route.path.length > 15
                                        ? "Spend Data Invoice"
                                        : "Spend Data Upload"
                                }}
                            </h5>
                        </CCol>
                        <CCol>
                            <div class="card-header-actions">
                                <CButton v-if="$route.path.length <= 15" color="secondary" class="m-2"
                                    @click="importModalForAPPO = true">Import AP & PO
                                </CButton>
                                <CButton v-if="$route.path.length <= 15" color="secondary" class="m-2"
                                    @click="importModal = true">Import PO
                                </CButton>
                                <CButton color="secondary" class="m-2" @click="$router.back()"
                                    v-if="$route.path.length > 15">
                                    Back to spend dashboard
                                </CButton>
                                <CButton color="primary" class="m-2" download="coreui-table-data.csv" target="_blank"
                                    @click="exportModal = true">Export Invoices
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <CCardBody>
                    <CRow>
                        <CCol sm="4">
                            <!-- <CInput placeholder="Search for vendor" :value.sync="searchVal" :lazy="800" horizontal /> -->
                        </CCol>
                        <CCol sm="4"></CCol>
                        <CCol sm="4">
                            <CSelect v-if="isSysAdmin || isGroupAdmin" :options="clientList"
                                placeholder="Filter on client" :value.sync="clientFilter" label="Client Filter:"
                                horizontal />
                        </CCol>
                    </CRow>

                    <br />

                    <CTabs variant="tabs" :active-tab="0">
                        <CTab title="Uncategorized Spend">
                            <br />
                            <CDataTable class="sticky-header-table" stickyHeader striped :items="approvedSpendList"
                                :fields="approvedSpendField" :column-filter="false" tableFilter theadTopSlot=""
                                itemsPerPageSelect :itemsPerPage="limit" pagination>
                                <!-- <CDataTable :items="approvedSpendList" :fields="approvedSpendField" :column-filter="false"
                                hover :itemsPerPageSelect="true" :tableFilterValue="vendorFilter"
                                :items-per-page="limit" @pagination-change="(item) => {
                                        limit = item;
                                        offset = 0;
                                        getSpends(this.clientFilter);
                                    }
                                    " @filtered-items-change="setCurrentItems"> -->
                                <template #client_name="{ item }">
                                    <td>{{ item.client.name || "" }}</td>
                                </template>
                                <template #action="{ item }">
                                    <td>
                                        <CButton color="success" @click="editOpportunityClickHandler(item)">Edit
                                        </CButton>
                                    </td>
                                </template>
                            </CDataTable>
                        </CTab>
                    </CTabs>
                </CCardBody>

                <CRow style="padding-bottom: 20px" v-if="pageCount > 0">
                    <CCol></CCol>
                    <CCol>
                        <CButton color="primary" class="m-2" download="coreui-table-data.csv" target="_blank"
                            :disabled="offset < 1" @click="printPrevious50">Previous
                        </CButton>
                        page {{ offset / limit + 1 }} of {{ pageCount }}
                        <CButton color="primary" class="m-2" download="coreui-table-data.csv" target="_blank"
                            :disabled="pageCount === offset / limit + 1" @click="printNext50">Next
                        </CButton>
                    </CCol>
                    <CCol> </CCol>
                </CRow>
            </CCard>
        </CCol>
        <ImportMulti title="Import AP & PO" :modal="importModalForAPPO" :selectClient="true"
            @close="importModalForAPPO = false"
            :filesInfo="[{ label: 'AP Spend', type: 'ap-spend-data' }, { label: 'PO Spend', type: 'po-spend-data-two' }]" />
        <Import title="Import PO" :modal="importModal" type="po-spend-data" :selectClient="true"
            @close="importModal = false" />

        <Export title="Export Spend Data" :modal="exportModal" type="spend-data" @close="exportModal = false" />

        <CModal title="Edit category" :show.sync="showEditCategory" centered fade class="disable-footer"
            :closeOnBackdrop="false">
            <div>Vendor Name: <strong>{{ selectedRowData.vendor_source }}</strong></div>
            <div>Vendor Catalog: <strong>{{ selectedRowData.vendor_catalog }}</strong></div>
            <div>Item Description: <strong>{{ selectedRowData.item_description }}</strong></div>
            <br />
            <div>
				<CInputRadio type="radio" id="outScope" label="Out of Scope"
					:checked="viewMode === false" @click="viewModeChangeHandler(false)" />
				<CInputRadio type="radio" id="inScope" label="in Scope"
				    :checked="viewMode === true" @click="viewModeChangeHandler(true)" />
			</div>
            <br />
            <div class="category-input" :class="{ 'input-error': !isValidForAddingCategories.primary }">
                <label>Primary*:</label>
                <v-select :loading="loadingPrimaryCategories" :disabled="loadingPrimaryCategories"
                    placeholder="Select primary category" label="name" :options="primaryCategories" :multiple="false"
                    v-model="primaryCategory" @input="categoryChangeHandler('primary')" />
            </div>
            <div class="category-input" :class="{ 'input-error': !isValidForAddingCategories.secondary }">
                <label>Secondary*:</label>
                <v-select :loading="loadingSecondaryCategories" :disabled="loadingSecondaryCategories"
                    placeholder="Select secondary category" label="name" :options="secondaryCategories"
                    :multiple="false" v-model="secondaryCategory" @input="categoryChangeHandler('secondary')" />
            </div>
            <div class="category-input" :class="{ 'input-error': !isValidForAddingCategories.sub }">
                <label>Sub*:</label>
                <v-select :loading="loadingSubCategories" :disabled="loadingSubCategories"
                    placeholder="Select sub category" label="name" :options="subCategories" :multiple="false"
                    v-model="subCategory" />
            </div>
            <CButton type="submit" color="primary" class="m-1" @click="saveCategory" :style="{ float: 'right' }">
                Save
            </CButton>
            <CButton type="submit" color="secondary" class="m-1" @click="showEditCategory = false"
                :style="{ float: 'right' }">
                Cancel
            </CButton>
        </CModal>
        <CElementCover v-if="spinner" :opacity="0.8" />
    </CRow>
</template>

<script>
// Store Data
import { storeData } from "../../store";

import XLSX from "xlsx";
import queries from "./queries";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import gql from "graphql-tag";

const approvedSpendField = [
    { key: "vendor_source", label: "Vendor Name" },
    { key: "spend_type", label: "Spend Type" },
    { key: "vendor_catalog", label: "Vendor Catalog" },
    { key: "item_description", label: "Item Description" },
    { key: "prime_category_name", label: "Prime Category" },
    { key: "secondary_category_name", label: "Secondary Category" },
    { key: "sub_category_name", label: "Sub Category" },
    { key: "total_spend", label: "Total Spend" },
    { key: "action", label: "Action" },
];

export default {
    components: {
        vSelect,
    },
    data() {
        return {
            approvedSpendField,
            viewMode : true,
            importModalForAPPO: false,
            importModal: false,
            exportModal: false,
            approvedSpendList: [],
            activeTab: 0,
            vendorFilter: null,
            fileType: "",
            pageCount: 0,
            limit: 5,
            offset: 0,

            clientList: storeData.clientList.filter(c => c.value !== "All"),
            clientFilter: "a8361072-903b-444f-b5d3-5e8c02d0db18",
            searchVal: "",
            spinner: false,
            showEditCategory: false,
            selectedRowData: {},
            isValidForAddingCategories: {
                primary: true,
                secondary: true,
                sub: true,
            },
            primaryCategories: [],
            primaryCategory: null,
            secondaryCategories: [],
            secondaryCategory: null,
            subCategories: [],
            subCategory: null,
            loadingPrimaryCategories: false,
            loadingSecondaryCategories: false,
            loadingSubCategories: false,
        };
    },
    computed: {
        isSysAdmin() {
            return storeData.currentUserDetails.role.name === "sys_admin";
        },
        isGroupAdmin() {
            return storeData.currentUserDetails.role.name === "group_admin";
        },
    },
    watch: {
        clientFilter() {
            this.getSpends(this.clientFilter);
        },
        // searchVal() {
        //     this.approvedSpendList = [];
        //     if (this.searchVal != "") {
        //         this.offset = 0;
        //         this.getSpends(this.clientFilter);
        //     } else {
        //         this.offset = 0;
        //         this.getSpends(this.clientFilter);
        //     }
        // },
    },
    methods: {
        // printPrevious50() {
        //     this.offset = this.offset - this.limit;
        //     this.getSpends(this.clientFilter);
        // },
        // printNext50() {
        //     this.offset = this.offset + this.limit;
        //     this.getSpends(this.clientFilter);
        // },
        // setCurrentItems(val) {
        //     this.currentItems = val;
        // },
        // filterBasedOnMonth(val, type) {
        //     if (type === "month") {
        //         this.approvedSpendList = this.approvedSpendList.filter(
        //             (el) =>
        //                 +(new Date(el.doc_date).getMonth() + 1) === +val &&
        //                 storeData.selected10Vendors.includes(el.remit_to_name)
        //         );
        //     } else if (type === "year") {
        //         this.approvedSpendList = this.approvedSpendList.filter(
        //             (el) =>
        //                 +new Date(el.doc_date).getFullYear() === +val &&
        //                 storeData.selected10Vendors.includes(el.remit_to_name)
        //         );
        //     } else if (type === "quarter") {
        //         const endingMonth = val * 3;
        //         const startingMonth = endingMonth - 2;
        //         this.approvedSpendList = this.approvedSpendList.filter(
        //             (el) =>
        //                 +new Date(el.doc_date).getMonth() + 1 >=
        //                 +startingMonth &&
        //                 +new Date(el.doc_date).getMonth() + 1 <= +endingMonth &&
        //                 storeData.selected10Vendors.includes(el.remit_to_name)
        //         );
        //     }
        // },
        async saveCategory() {
            if(this.viewMode == true){

                if (!this.primaryCategory) {
                this.isValidForAddingCategories.primary = false;
                return;
                }
                else {
                    this.isValidForAddingCategories.primary = true;
                }
                if (!this.secondaryCategory) {
                    this.isValidForAddingCategories.secondary = false;
                    return;
                }
                else {
                    this.isValidForAddingCategories.secondary = true;
                }
                if (!this.subCategory) {
                    this.isValidForAddingCategories.sub = false;
                    return;
                }
                else {
                    this.isValidForAddingCategories.sub = true;
                }
                if (!this.primaryCategory) {
                    this.isValidForAddingCategories.primary = false;
                    return;
                }
                else {
                    this.isValidForAddingCategories.primary = true;
                }
                if (!this.secondaryCategory) {
                    this.isValidForAddingCategories.secondary = false;
                    return;
                }
                else {
                    this.isValidForAddingCategories.secondary = true;
                }
                if (!this.subCategory) {
                    this.isValidForAddingCategories.sub = false;
                    return;
                }
                else {
                    this.isValidForAddingCategories.sub = true;
                }

                await this.$apollo
                .mutate({
                    mutation: SPENDMD_DB_UPDATE_SPEND_CATEGORY,
                    variables: {
                        spend_id: this.selectedRowData.id,
                        prime_id: this.primaryCategory.id,
                        secondary_id: this.secondaryCategory.id,
                        sub_id: this.subCategory.id
                    }
                })
                .then((res) => {
                }).catch((err) => {
                    console.log(err);
                });
            }
            else if(this.viewMode == false){
                await this.$apollo
                .mutate({
                    mutation: UPDATE_SPENDMD_DB_SPEND_DATA_NEW,
                    variables: {
                        spend_id: this.selectedRowData.id,
                    }
                })
                .then((res) => {
                }).catch((err) => {
                    console.log(err);
                });

            }
            this.getSpends(this.clientFilter);

            this.showEditCategory = false;
        },
        editOpportunityClickHandler(item) {
            this.selectedRowData = item;
            this.showEditCategory = true;
        },
        getSpends(clientId = null) {
            this.spinner = true;
            if (clientId === "All") {
                clientId = null;
            }

            this.$apollo
                .mutate({
                    mutation: queries.GET_SPEND_DATA,
                    variables: {
                        // vendor_name:
                        //     this.searchVal !== ""
                        //         ? `%%${this.searchVal.trim()}%%`
                        //         : null,
                        offset: this.offset,
                        // limit: this.limit,
                        client: clientId ?? "2cfb47a8-a4c8-43c8-909c-396ace5a38e4",
                    },
                })
                .then((res) => {
                    const response = res.data.spendmd_db_spend_data_new_aggregate.nodes;
                    this.approvedSpendList = [...response];

                    // For page count

                    // this.pageCount =
                    //     Math.ceil(
                    //         res?.data?.spendmd_db_spend_data_new_aggregate
                    //             ?.aggregate?.count / this.limit
                    //     ) || 0;

                    // if (this.$route.path.includes("month=")) {
                    //     this.filterBasedOnMonth(
                    //         this.$route.params.month,
                    //         "month"
                    //     );
                    // } else if (this.$route.path.includes("year=")) {
                    //     this.filterBasedOnMonth(
                    //         this.$route.params.year,
                    //         "year"
                    //     );
                    // } else if (this.$route.path.includes("quarter=")) {
                    //     this.filterBasedOnMonth(
                    //         this.$route.params.quarter,
                    //         "quarter"
                    //     );
                    // }

                    this.spinner = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.spinner = false;
                });
        },
        async getPrimaryCategories() {
            this.loadingPrimaryCategories = true;
            await this.$apollo
                .mutate({
                    mutation: SPENDMD_DB_PRIME_CATEGORIES,
                })
                .then((res) => {
                    this.primaryCategories = res.data.spendmd_db_prime_categories;
                }).catch((err) => {
                    console.log(err);
                });
            this.loadingPrimaryCategories = false;
        },
        async getSecondaryCategories() {
            this.loadingSecondaryCategories = true;
            await this.$apollo
                .mutate({
                    mutation: SPENDMD_DB_SECONDARY_CATEGORIES,
                    variables: {
                        prime_cat: this.primaryCategory?.id || null
                    }
                })
                .then((res) => {
                    this.secondaryCategories = res.data.spendmd_db_secondary_categories;
                }).catch((err) => {
                    console.log(err);
                });

            this.loadingSecondaryCategories = false;
        },
        async getSubCategories() {
            this.loadingSubCategories = true;
            await this.$apollo
                .mutate({
                    mutation: SPENDMD_DB_SUB_CATEGORIES,
                    variables: {
                        secondary_cat: this.secondaryCategory?.id || null
                    }
                })
                .then((res) => {
                    this.subCategories = res.data.spendmd_db_sub_categories;
                }).catch((err) => {
                    console.log(err);
                });

            this.loadingSubCategories = false;
        },
        async categoryChangeHandler(type) {
            if (type === "primary") {
                if (!this.primaryCategory) {
                    this.secondaryCategories = [];
                }
                else {
                    await this.getSecondaryCategories();
                }
                this.secondaryCategory = null;
                this.subCategories = [];
                this.subCategory = null;
            }
            else {
                if (!this.secondaryCategory) {
                    this.subCategories = [];
                }
                else {
                    await this.getSubCategories();
                }
                this.subCategory = null;
            }
        },
        async viewModeChangeHandler(val) {
			this.viewMode = val;
            if(this.viewMode == false)
                {
                    this.loadingPrimaryCategories = true;
                    this.loadingSecondaryCategories =  true;
                    this.loadingSubCategories = true;
                }
            else if(this.viewMode == true)
                {
                    this.loadingPrimaryCategories = false
                    this.loadingSecondaryCategories = false
                    this.loadingSubCategories = false
                }
		},

    },
    async mounted() {
        this.getSpends(this.clientFilter);
        await this.getPrimaryCategories();
    },
    created() {
        // if (this.$route.path.includes("vendor-name=")) {
        //     this.vendorFilter = this.$route.params.vendor_name;
        // }
    },
};

const SPENDMD_DB_PRIME_CATEGORIES = gql`
    query {
        spendmd_db_prime_categories(
            order_by: {name: asc}
        ) {
                id
                name
            }
        }`;

const SPENDMD_DB_SECONDARY_CATEGORIES = gql`
    query(
        $prime_cat: Int
    ) {
        spendmd_db_secondary_categories(
            order_by: {name: asc},
            where: {
                prime_category_id: {_eq: $prime_cat}
            }
        ) {
            id
            name
        }
    }`;

const SPENDMD_DB_SUB_CATEGORIES = gql`
    query(
        $secondary_cat: Int
    ) {
        spendmd_db_sub_categories(
            order_by: {name: asc},
            where: {
                secondary_category_id: {_eq: $secondary_cat}
            }
        ) {
            id
            name
        }
    }`;

const UPDATE_SPENDMD_DB_SPEND_DATA_NEW = gql`
    mutation (
        $spend_id: Int
        ) {
        update_spendmd_db_spend_data_new(
            where: {
                id: {_eq: $spend_id}
            }
        _set: {
            status_id: 2
            status_description: "Out of Scope"
            }) {
            affected_rows
            }
        }`;

const SPENDMD_DB_UPDATE_SPEND_CATEGORY = gql`
    mutation (
        $spend_id: Int,
        $prime_id: Int,
        $secondary_id: Int,
        $sub_id: Int
    ) {
        spendmd_db_update_spend_category(
            args: {
            prime_id: $prime_id,
            secondary_id: $secondary_id,
            spend_id: $spend_id,
            sub_id: $sub_id
            }
        ) {
            id
        }
    }`;

</script>
<style>
.textField {
    width: 40px;
}

.input-error {
    color: red;
}

.input-error::v-deep>.v-select {
    border: 1px solid red;
}

.input-error::v-deep>input {
    border: 1px solid red;
}

.category-input {
    padding: 0;
    margin-bottom: 1.5rem;
}
</style>
